import {createSlice, isAnyOf} from '@reduxjs/toolkit';
import {
  cancelWorkday,
  createWorkday,
  hardRefreshWorkdays,
  loadWorkdays,
  replaceWorkday,
  updateWorkday,
} from './actions';
import {workdaysAdapter} from './adapters';
import {initialState} from './initialState';

const slice = createSlice({
  name: 'workday',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadWorkdays.fulfilled, (state, action) => {
        workdaysAdapter.setMany(state.workdays, action.payload);
        state.isLoading = false;
      })
      .addCase(hardRefreshWorkdays.fulfilled, (state, action) => {
        workdaysAdapter.setAll(state.workdays, action.payload);
        state.isLoading = false;
      })
      .addCase(createWorkday.fulfilled, (state, action) => {
        workdaysAdapter.addOne(state.workdays, action.payload);
        state.isLoading = false;
      })
      .addCase(updateWorkday.fulfilled, (state, action) => {
        const workday = action.payload;
        workdaysAdapter.updateOne(state.workdays, {
          id: workday.id,
          changes: workday,
        });
        state.isLoading = false;
      })
      .addCase(cancelWorkday, (state, action) => {
        workdaysAdapter.removeOne(state.workdays, action.payload);
      })
      .addCase(replaceWorkday, (state, action) => {
        const workday = action.payload;
        workdaysAdapter.updateOne(state.workdays, {
          id: workday.id,
          changes: workday,
        });
      })
      .addMatcher(
        isAnyOf(loadWorkdays.pending, createWorkday.pending, updateWorkday.pending, hardRefreshWorkdays.pending),
        (state) => {
          state.isLoading = true;
        },
      )
      .addMatcher(
        isAnyOf(loadWorkdays.rejected, createWorkday.rejected, updateWorkday.rejected, hardRefreshWorkdays.rejected),
        (state) => {
          state.isLoading = false;
        },
      );
  },
});

export const {reducer: workdayReducer} = slice;
